import { render, staticRenderFns } from "./PageGraph.vue?vue&type=template&id=81325c50&scoped=true"
import script from "./PageGraph.vue?vue&type=script&lang=js"
export * from "./PageGraph.vue?vue&type=script&lang=js"
import style0 from "./PageGraph.vue?vue&type=style&index=0&id=81325c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81325c50",
  null
  
)

export default component.exports